import { LocaleId, TranslationDictionaryMapping } from '@i18n';
import { FeatureMultiPlanTranslationDictionary } from './feature-multi-plan-dictionary.interface';

export const translation: TranslationDictionaryMapping<FeatureMultiPlanTranslationDictionary> =
  {
    [LocaleId.English_GreatBritain]: {
      PLAN_SALE_PAGE_TITLE:
        'Add instant protection for your kitchen appliances',
      PLAN_SALE_PAGE_SUBTITLE:
        'Our bundle costs less than protecting each appliance separately - giving you more coverage for your money.*',
      PLAN_SALE_PAGE_PRICE_FROM: 'From {{ price }} a month',
      PLAN_SALE_PAGE_CANCEL_ANYTIME: 'No fixed term contract, cancel anytime',
      PRICE_TAX_DISCLAIMER:
        'Price includes any applicable Insurance Premium Tax or VAT and is subject to any inflation and tax rate changes.',
      PLAN_SALE_PAGE_BENEFITS_LIST: [
        {
          iconName: 'shield-check',
          text: 'Protect the appliances you rely on',
          description: 'Any brand, up to 5 years old',
        },
        {
          iconName: 'heart',
          text: 'No excess to pay',
          description: 'No hidden repair costs for making a claim',
        },
        {
          iconName: 'screwdriver-wrench',
          text: 'Unlimited callouts',
          description: 'Claim as many times as you need, no limits',
        },
        {
          iconName: 'house-circle-check',
          text: 'Breakdown and accidental damage cover',
          description: "If they break, we'll repair them",
        },
        {
          iconName: 'dolly',
          text: "A replacement if it can't be fixed",
          description: 'With the same or similar features',
        },
      ],
      PLAN_SALE_PAGE_PROVIDED_BY: 'Provided by Domestic & General',
      PLAN_SALE_PAGE_HEADER_BADGE: 'PROTECT MORE - PAY LESS',
      PLAN_SALE_PAGE_MULTI_APPLIANCE_CARD_TITLE:
        'Build your kitchen appliance bundle',
      PLAN_SALE_PAGE_MULTI_APPLIANCE_CARD_DESCRIPTION:
        'Protect your {{ applianceName }} PLUS the other appliances that you rely on from breakdowns and damage.',
      PLAN_SALE_PAGE_MULTI_APPLIANCE_CARD_PRICE:
        'Protect two or more From {{ price}} a month',
      PLAN_SALE_PAGE_MULTI_APPLIANCE_CARD_CTA_BUILD_YOUR_BUNDLE:
        'Build Your Bundle',
      PLAN_SALE_PAGE_MULTI_APPLIANCE_CARD_CTA_BUILD_YOUR_BUNDLE_DISCLAIMER_PREFIX:
        '*Bundle pricing represents a discount compared to the total cost of insuring the same kitchen appliances on an individual basis through',
      PLAN_SALE_PAGE_MULTI_APPLIANCE_CARD_CTA_BUILD_YOUR_BUNDLE_DISCLAIMER_SUFFIX:
        'Savings amount varies based on the specific combination of appliances protected under the bundle policy. Comparison based on appliances valued between £301 - £750 with the initial appliance being in guarantee and all subsequent appliances being out of guarantee, where you hold the policy for a year. Prices correct as of 26 Nov 2025.',
      PLAN_SALE_PAGE_MULTI_APPLIANCE_CARD_REGISTERED_APPLIANCE_TITLE:
        'YOUR REGISTERED APPLIANCE',
      PLAN_SALE_PAGE_MULTI_APPLIANCE_CARD_REGISTERED_APPLIANCE_DISCLAIMER:
        'Must be included with cover',
      PLAN_SALE_PAGE_MULTI_APPLIANCE_CARD_SELECT_APPLIANCES:
        'Select appliances...',
      PLAN_SALE_PAGE_MULTI_APPLIANCE_CARD_APPLIANCES_DISCLAIMER:
        'Please note this bundle is not available for American-style fridge freezers or range cookers.',
      PLAN_SALE_PAGE_MULTI_APPLIANCE_CARD_CTA_CONTINUE: 'Continue',
      PLAN_SALE_PAGE_SINGLE_APPLIANCE_CARD_TITLE: '{{ applianceName }}',
      PLAN_SALE_PAGE_SINGLE_APPLIANCE_CARD_SUBTITLE:
        'Add extra protection beyond your guarantee',
      PLAN_SALE_PAGE_SINGLE_APPLIANCE_CARD_PRICE_PREFIX:
        'Single appliance cover',
      PLAN_SALE_PAGE_SINGLE_APPLIANCE_CARD_PRICE_VALUE: '{{ price }} a month',
      PLAN_SALE_PAGE_SINGLE_APPLIANCE_CARD_CTA: 'Find out more',
      PLAN_SALE_PAGE_CHOOSE_COVER_OR_CONTINUE_REGISTERING_TITLE:
        'Choose what you want to cover or continue registering',
      PLAN_SALE_REGISTER_ONLY: 'No thanks, register only',
      APPLIANCE_DETAILS_PAGE_TITLE:
        'Tell us a little more about your appliances',
      APPLIANCE_DETAILS_PAGE_BENEFITS_LIST_ITEMS_COVERED_TITLE:
        "What's covered",
      APPLIANCE_DETAILS_PAGE_BENEFITS_LIST_ITEMS_ADDITIONAL_TITLE:
        "Plus you'll get",
      APPLIANCE_DETAILS_FORM_MANUFACTURER_REQUIRED: 'Select a manufacturer',
      APPLIANCE_DETAILS_FORM_PURCHASE_PRICE_REQUIRED: 'Select a purchase price',
      APPLIANCE_DETAILS_FORM_PURCHASE_YEAR_REQUIRED: 'Select a purchase year',
      APPLIANCE_DETAILS_FORM_WAS_PURCHASED_IN_THE_LAST_YEAR_REQUIRED:
        'Select if bought in the last 12 months',
      APPLIANCE_DETAILS_FORM_PURCHASE_DATE_LABEL: 'When did you buy it?',
      APPLIANCE_DETAILS_FORM_CTA_CHANGE_APPLIANCES: 'Change appliances',
      APPLIANCE_DETAILS_FORM_CTA_CONTINUE: 'Continue',
      REVIEW_COVER_PAGE_TITLE: 'Review Your Cover',
      REVIEW_COVER_PAGE_BENEFITS_LIST_ITEMS_COVERED_TITLE: "What's covered",
      REVIEW_COVER_PAGE_BENEFITS_LIST_ITEMS_ADDITIONAL_TITLE: "Plus you'll get",
      REVIEW_COVER_PAGE_CTA_CHANGE_APPLIANCES: 'Change appliances',
      REVIEW_COVER_PAGE_CTA_CHANGE_APPLIANCE_DETAILS:
        'Change appliance details',
      REVIEW_COVER_PAGE_CTA_CONTINUE: 'Continue',
      PLAN_SALE_PAGE_SINGLE_APPLIANCE_CARD_PRICE_VALUE_SLASH:
        '{{ price }}/month',
      PLAN_SALE_PAGE_ALT_BENEFITS_LIST: [
        'Protect kitchen appliances up to 5 years old',
        'No excess or hidden cost to pay when making a claim',
        'Unlimited callouts',
        'Breakdown and accidental damage cover',
        "A replacement if it can't be fixed (same or similar model)",
      ],
      PLAN_SALE_ALT_DESCRIPTION_HEADER:
        'Add instant cover for the appliances that you rely on everyday',
      PLAN_SALE_ALT_INCLUSION_PANEL_TITLE:
        "What's included with Appliance Care cover?",
      PLAN_SALE_ALT_TRUSTPILOT_HINT:
        'See what our customers say about Domestic & General',
      PLAN_SALE_ALT_BUNDLE_PANEL_TITLE:
        'Add instant extra protection for your {{ applianceName }}',
      PLAN_SALE_ALT_BUNDLE_PANEL_REGISTERED_SUBHEADING:
        'your registered appliance',
      PLAN_SALE_ALT_BUNDLE_PANEL_SUBTITLE:
        'Cover another appliance for an extra {{ additionalPrice }}/month',
      PLAN_SALE_PAGE_ALT_CTA_CONTINUE:
        'Continue to protection (for {{ applianceCount }} appliance(s))',
      STEP_TITLE_EXTRA_COVER_OPTIONAL: 'Extra cover (optional)',
      STEP_TITLE_REVIEW_COVER: 'Review cover',
    },
    [LocaleId.English_Ireland]: {
      PLAN_SALE_PAGE_TITLE:
        'Add instant protection for your kitchen appliances',
      PLAN_SALE_PAGE_SUBTITLE:
        'Our bundle costs less than protecting each appliance separately - giving you more coverage for your money.*',
      PLAN_SALE_PAGE_PRICE_FROM: 'From {{ price }} a month',
      PLAN_SALE_PAGE_CANCEL_ANYTIME: 'No fixed term contract, cancel anytime',
      PRICE_TAX_DISCLAIMER:
        'Price includes any applicable Insurance Premium Tax or VAT and is subject to any inflation and tax rate changes.',
      PLAN_SALE_PAGE_BENEFITS_LIST: [
        {
          iconName: 'shield-check',
          text: 'Protect the appliances you rely on',
          description: 'Any brand, up to 5 years old',
        },
        {
          iconName: 'heart',
          text: 'No excess to pay',
          description: 'No hidden repair costs for making a claim',
        },
        {
          iconName: 'screwdriver-wrench',
          text: 'Unlimited callouts',
          description: 'Claim as many times as you need, no limits',
        },
        {
          iconName: 'house-circle-check',
          text: 'Breakdown and accidental damage cover',
          description: "If they break, we'll repair them",
        },
        {
          iconName: 'dolly',
          text: "A replacement if it can't be fixed",
          description: 'With the same or similar features',
        },
      ],
      PLAN_SALE_PAGE_PROVIDED_BY: 'Provided by Domestic & General',
      PLAN_SALE_PAGE_HEADER_BADGE: 'PROTECT MORE - PAY LESS',
      PLAN_SALE_PAGE_MULTI_APPLIANCE_CARD_TITLE:
        'Build your kitchen bundle and save',
      PLAN_SALE_PAGE_MULTI_APPLIANCE_CARD_DESCRIPTION:
        'Protect your {{ applianceName }} PLUS the other appliances that you rely on from breakdowns and damage.',
      PLAN_SALE_PAGE_MULTI_APPLIANCE_CARD_PRICE:
        'Protect two or more From {{ price}} a month',
      PLAN_SALE_PAGE_MULTI_APPLIANCE_CARD_CTA_BUILD_YOUR_BUNDLE:
        'Build Your Bundle',
      PLAN_SALE_PAGE_MULTI_APPLIANCE_CARD_CTA_BUILD_YOUR_BUNDLE_DISCLAIMER_PREFIX:
        '*Bundle pricing represents a discount compared to the total cost of insuring the same kitchen appliances on an individual basis through',
      PLAN_SALE_PAGE_MULTI_APPLIANCE_CARD_CTA_BUILD_YOUR_BUNDLE_DISCLAIMER_SUFFIX:
        'Savings amount varies based on the specific combination of appliances protected under the bundle policy. Comparison based on appliances valued between £301 - £750 with the initial appliance being in guarantee and all subsequent appliances being out of guarantee, where you hold the policy for a year. Prices correct as of 26 Nov 2025.',
      PLAN_SALE_PAGE_MULTI_APPLIANCE_CARD_REGISTERED_APPLIANCE_TITLE:
        'YOUR REGISTERED APPLIANCE',
      PLAN_SALE_PAGE_MULTI_APPLIANCE_CARD_REGISTERED_APPLIANCE_DISCLAIMER:
        'Must be included with cover',
      PLAN_SALE_PAGE_MULTI_APPLIANCE_CARD_SELECT_APPLIANCES:
        'Select appliances...',
      PLAN_SALE_PAGE_MULTI_APPLIANCE_CARD_APPLIANCES_DISCLAIMER:
        'Please note this bundle is not available for American-style fridge freezers or range cookers.',
      PLAN_SALE_PAGE_MULTI_APPLIANCE_CARD_CTA_CONTINUE: 'Continue',
      PLAN_SALE_PAGE_SINGLE_APPLIANCE_CARD_TITLE: '{{ applianceName }}',
      PLAN_SALE_PAGE_SINGLE_APPLIANCE_CARD_SUBTITLE:
        'Add extra protection beyond your guarantee',
      PLAN_SALE_PAGE_SINGLE_APPLIANCE_CARD_PRICE_PREFIX:
        'Single appliance cover',
      PLAN_SALE_PAGE_SINGLE_APPLIANCE_CARD_PRICE_VALUE: '{{ price }} a month',
      PLAN_SALE_PAGE_SINGLE_APPLIANCE_CARD_CTA: 'Find out more',
      PLAN_SALE_PAGE_CHOOSE_COVER_OR_CONTINUE_REGISTERING_TITLE:
        'Choose what you want to cover or continue registering',
      PLAN_SALE_REGISTER_ONLY: 'No thanks, register only',
      APPLIANCE_DETAILS_PAGE_TITLE:
        'Tell us a little more about your appliances',
      APPLIANCE_DETAILS_PAGE_BENEFITS_LIST_ITEMS_COVERED_TITLE:
        "What's covered",
      APPLIANCE_DETAILS_PAGE_BENEFITS_LIST_ITEMS_ADDITIONAL_TITLE:
        "Plus you'll get",
      APPLIANCE_DETAILS_FORM_MANUFACTURER_REQUIRED: 'Select a manufacturer',
      APPLIANCE_DETAILS_FORM_PURCHASE_PRICE_REQUIRED: 'Select a purchase price',
      APPLIANCE_DETAILS_FORM_PURCHASE_YEAR_REQUIRED: 'Select a purchase year',
      APPLIANCE_DETAILS_FORM_WAS_PURCHASED_IN_THE_LAST_YEAR_REQUIRED:
        'Select if bought in the last 12 months',
      APPLIANCE_DETAILS_FORM_PURCHASE_DATE_LABEL: 'When did you buy it?',
      APPLIANCE_DETAILS_FORM_CTA_CHANGE_APPLIANCES: 'Change appliances',
      APPLIANCE_DETAILS_FORM_CTA_CONTINUE: 'Continue',
      REVIEW_COVER_PAGE_TITLE: 'Review Your Cover',
      REVIEW_COVER_PAGE_BENEFITS_LIST_ITEMS_COVERED_TITLE: "What's covered",
      REVIEW_COVER_PAGE_BENEFITS_LIST_ITEMS_ADDITIONAL_TITLE: "Plus you'll get",
      REVIEW_COVER_PAGE_CTA_CHANGE_APPLIANCES: 'Change appliances',
      REVIEW_COVER_PAGE_CTA_CHANGE_APPLIANCE_DETAILS:
        'Change appliance details',
      REVIEW_COVER_PAGE_CTA_CONTINUE: 'Continue',
      PLAN_SALE_PAGE_SINGLE_APPLIANCE_CARD_PRICE_VALUE_SLASH:
        '{{ price }}/month',
      PLAN_SALE_PAGE_ALT_BENEFITS_LIST: [
        'Protect kitchen appliances up to 5 years old',
        'No excess or hidden cost to pay when making a claim',
        'Unlimited callouts',
        'Breakdown and accidental damage cover',
        "A replacement if it can't be fixed (same or similar model)",
      ],
      PLAN_SALE_ALT_DESCRIPTION_HEADER:
        'Add instant cover for the appliances that you rely on everyday',
      PLAN_SALE_ALT_INCLUSION_PANEL_TITLE:
        "What's included with Appliance Care cover?",
      PLAN_SALE_ALT_TRUSTPILOT_HINT:
        'See what our customers say about Domestic & General',
      PLAN_SALE_ALT_BUNDLE_PANEL_TITLE:
        'Add instant extra protection for your {{ applianceName }}',
      PLAN_SALE_ALT_BUNDLE_PANEL_REGISTERED_SUBHEADING:
        'Your registered appliance',
      PLAN_SALE_ALT_BUNDLE_PANEL_SUBTITLE:
        'Cover another appliance for an extra {{ additionalPrice }}/month',
      PLAN_SALE_PAGE_ALT_CTA_CONTINUE:
        'Continue to protection (for {{ applianceCount }} appliance(s))',
      STEP_TITLE_EXTRA_COVER_OPTIONAL: 'Extra cover (optional)',
      STEP_TITLE_REVIEW_COVER: 'Review cover',
    },
  };
